export enum DelegatedAdminType {
    WorkCompany = "WorkCompany",
    HRL2Code = "HRL2Code",
    HRL5Code = "HRL5Code"
}